import React from "react";
import ContentPanel from "../../components/elements/Base/ContentPanel";
import Title from "../../components/elements/Base/Title";
import WidthWrapper from "../../components/elements/Base/WidthWrapper";
import MetaElement from "../../components/elements/MetaElement";

const DetaliiLivrare = (props) => {
  return (
    <WidthWrapper className="xsmall">
      <MetaElement pageId="info/detalii-livrare" />

      <ContentPanel>
        <Title variant="title">Detalii Livrare</Title>
        <p>
          Toate comenzile înregistrate vor fi livrate prin intermediul
          serviciilor de curierat rapid, cu exceptia cazului in care este
          selectata optiunea "Ridicare Personala"
        </p>

        <p>
          Taxa de livrare în țară este de 15 Lei per comanda, sau gratuit la
          comenzi în valoare de 190 Lei sau mai mult.{" "}
        </p>

        <p>
          Termenul de livrare este de 1-3 zile lucrătoare de la plasarea
          comenzii. În zilele de weekend (sâmbătă și duminică) nu se livrează.
        </p>

        <p>
          În momentul expedierii coletului, veți fi notificat prin e-mail și/sau
          SMS. De asemenea, puteți verifica oricând statusul comenzii pe Site în
          secțiunea "Comenzile mele".
        </p>

        <p>
          Agentul companiei de curierat vă va contacta telefonic pentru a vă
          livra coletul. În cazul în care acesta nu vă găsește la adresă, și nu
          puteți fi contactat(ă) telefonic, coletul se va întoarce la centrul de
          livrare. La centrul de livrare, firma de curierat va stabili o nouă
          dată pentru a expedia coletul.
        </p>

        <p>Coletul va fi păstrat maxim 5 (cinci) zile la firma de curierat.</p>

        <p>
          Pentru TRANSPORT INTERNAȚIONAL vă rugăm să ne contactați la adresa de
          e-mail contact@krit.ro
        </p>
      </ContentPanel>

      <ContentPanel>
        <Title variant="title">Detalii Plata</Title>

        <p>Plata se poate efectua prin următoarele modalități:</p>

        <ul>
          <li>Online prin card bancar</li>
          <li>Ramburs la curier</li>
          <li>Transfer bancar</li>
          <li>
            Cash sau card bancar la sediu (doar în cazul comenzilor ridicate
            personal)
          </li>
        </ul>

        <p>
          In cazul optiunii de plata " Online prin card bancar " veti fi
          redirectionat catre pagina securizata a procesatorului de plati unde
          veti completa un formular cu informatiile despre cardul dumneavoastra.
        </p>

        <p>
          Platile cu carduri de credit/debit emise sub sigla Visa si MasterCard
          (Visa/Visa Electron si MasterCard/Maestro) se efectuaeaza prin
          intermediul sistemului "3-D Secure" dezvoltat de organizatiile de
          carduri Visa/MasterCard si care asigura tranzactiilor on-line acelasi
          nivel de securitate ca al celor realizate la bancomat sau in mediul
          fizic, la comerciant.
        </p>

        <p>
          "3-D Secure" asigura in primul rand ca nici o informatie legata de
          cardul dumneavoastra nu este transferata sau stocata, la nici un
          moment de timp, pe serverele magazinului virtual.
        </p>

        <p>
          Important de stiut! - Pentru platile prin card bancar nu este perceput
          nici un comision de la detinatorul de card!
        </p>
      </ContentPanel>
    </WidthWrapper>
  );
};

export default DetaliiLivrare;
